import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/globals.css'
import './i18n'
import { AuthProvider } from './hooks/useAuth'
import { LicenseProvider } from './hooks/useLicense'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <LicenseProvider>
        <App />
      </LicenseProvider>
    </AuthProvider>
  </StrictMode>,
)
